import { put, all, takeLatest } from 'redux-saga/effects';

import {
    PATCH_PROTOCOL_ISSUE_REQUEST,
    PATCH_PROTOCOL_ISSUE_SUCCESS,
    PATCH_PROTOCOL_ISSUE_FAIL
} from '../../actions';
import {
    patchProtocolIssueSuccess,
    patchProtocolIssueFail,
    patchProtocolIssue,
    getIssue
} from '../../action-creators';

import { simpleRequest } from '../modules/request';
import { normalizeIssue } from '../modules/normalization';
import { responseHelper } from '../modules/promise';
import i18n from '../../../i18next';

function onSuccessCallback(data: any) {
    return normalizeIssue(data);
}

type IPatchIssueAction = RT<typeof patchProtocolIssue>;
type IPatchIssueFailAction = RT<typeof patchProtocolIssueFail>;

const requestEffect = simpleRequest<IPatchIssueAction>({
    success: patchProtocolIssueSuccess,
    failure: patchProtocolIssueFail,
    getUrl: (action) => `protocol_issue/${action.issueId}/`,
    getBody: (action) => action.payload,
    getEntityId: (action) => action.issueId,
    method: 'PATCH',
    enableOffline: true
});

const responseEffect = responseHelper({
    actionName: PATCH_PROTOCOL_ISSUE_SUCCESS,
    processFn: onSuccessCallback
});

const lang = i18n.language as ILang;
export default all([
    takeLatest(PATCH_PROTOCOL_ISSUE_REQUEST, requestEffect),
    takeLatest(PATCH_PROTOCOL_ISSUE_FAIL, function* (action: IPatchIssueFailAction) {
        if (action.itemId == null) return;
        yield put(getIssue(action.itemId, lang));
    }),
    responseEffect
]);